import React, { useCallback } from 'react'
import { Canvas } from '@react-three/fiber'
import { Environment, OrbitControls } from '@react-three/drei'
import styled from 'styled-components'
import * as THREE from 'three'
import { useGlobalStore } from '@/stores/globalStore'
import { FloorMesh } from '../model/types'
import { FLOOR_LAYER_MAP } from '../model/constants'
import BuildingModel from '../lib/BuildingModel'
import { SCENE_LIGHTING } from '../model/scene-lighting'

const ModelViewer: React.FC = () => {
  const setActiveLayer = useGlobalStore(state => state.setActiveLayer)

  const onFloorClick = useCallback(
    (floor: FloorMesh) => {
      const layerId = FLOOR_LAYER_MAP[floor.name.toLowerCase()]
      if (layerId) {
        setActiveLayer(layerId)
      }
    },
    [setActiveLayer],
  )

  return (
    <Wrapper>
      <CanvasWrapper>
        <Canvas
          camera={{ position: [30, 25, 30], fov: 50 }}
          gl={{
            toneMapping: THREE.ACESFilmicToneMapping,
            toneMappingExposure: SCENE_LIGHTING.exposure,
            outputColorSpace: THREE.SRGBColorSpace,
          }}
        >
          <color
            attach="background"
            args={['#e2e2e2']}
          />
          <Environment
            preset="studio"
            environmentIntensity={SCENE_LIGHTING.environmentIntensity}
          />
          <ambientLight intensity={SCENE_LIGHTING.ambient} />
          <hemisphereLight
            color="#ffffff"
            groundColor="#9a9a9a"
            intensity={SCENE_LIGHTING.hemisphere}
          />
          <directionalLight
            position={[12, 18, 10]}
            intensity={SCENE_LIGHTING.key}
          />
          <directionalLight
            position={[-12, 14, -8]}
            intensity={SCENE_LIGHTING.fill}
          />
          <directionalLight
            position={[0, 8, -18]}
            intensity={SCENE_LIGHTING.rim}
          />
          <mesh
            rotation={[-Math.PI / 2, 0, 0]}
            position={[0, -0.01, 0]}
          >
            <planeGeometry args={[200, 200]} />
            <meshStandardMaterial color="#d0d0d0" />
          </mesh>
          <BuildingModel onFloorClick={onFloorClick} />
          <OrbitControls />
        </Canvas>
      </CanvasWrapper>
    </Wrapper>
  )
}

export default ModelViewer

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vh - 60px);
`

const CanvasWrapper = styled.div`
  width: 100%;
  height: 100%;
`
